export default "__VITE_ASSET__mcS$NYJD__"